import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IconTask',
  props: {
  width: {
    type: Number,
    default: 16,
  },
  height: {
    type: Number,
    default: 17,
  },
  color: {
    type: String,
    default: "main-black",
  },
},
  setup(__props) {

const props = __props;

const setColor = computed(() => {
  return `var(--${props.color})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M2 8.5C2 8.94267 2.3922 9.3 2.87805 9.3C3.3639 9.3 3.7561 8.94267 3.7561 8.5C3.7561 8.05733 3.3639 7.7 2.87805 7.7C2.3922 7.7 2 8.05733 2 8.5ZM2 5.3C2 5.74267 2.3922 6.1 2.87805 6.1C3.3639 6.1 3.7561 5.74267 3.7561 5.3C3.7561 4.85733 3.3639 4.5 2.87805 4.5C2.3922 4.5 2 4.85733 2 5.3ZM2 11.7C2 12.1391 2.39611 12.5 2.87805 12.5C3.35999 12.5 3.7561 12.1391 3.7561 11.7C3.7561 11.2609 3.36659 10.9 2.87805 10.9C2.38951 10.9 2 11.2609 2 11.7ZM14 11.7C14 11.4054 13.7379 11.1667 13.4146 11.1667H5.21951C4.89622 11.1667 4.63415 11.4054 4.63415 11.7C4.63415 11.9946 4.89622 12.2333 5.21951 12.2333H13.4146C13.7379 12.2333 14 11.9946 14 11.7ZM14 8.5C14 8.20545 13.7379 7.96667 13.4146 7.96667H5.21951C4.89622 7.96667 4.63415 8.20545 4.63415 8.5C4.63415 8.79455 4.89622 9.03333 5.21951 9.03333H13.4146C13.7379 9.03333 14 8.79455 14 8.5ZM5.21951 5.83333H13.4146C13.7379 5.83333 14 5.59455 14 5.3C14 5.00545 13.7379 4.76667 13.4146 4.76667H5.21951C4.89622 4.76667 4.63415 5.00545 4.63415 5.3C4.63415 5.59455 4.89622 5.83333 5.21951 5.83333Z",
      fill: setColor.value
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})